"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Paragraph = (props) => ((0, jsx_runtime_1.jsx)("p", { ...props, className: "overflow-hidden whitespace-pre-line text-sm text-slate-500" }));
exports.Paragraph = Paragraph;
